let DISPLAY_SETTINGS = {
    endpoints: {
        subscribe: ":backend_url/api/v1/directory/subscribe/",
        unsubscribe: ":backend_url/api/v1/directory/subscribe/:id/"
    },
    statistics: {
        endpoints: {
            general: "/api/v1/directory/statistics/",
        },
        items: [{
                code: 'organization_members',
                verbose: 'Кількість Учасників',
            }, {
                code: 'organization_subjects',
                verbose: 'Кількість Суб\'єктів взаємодії',
            }, {
                code: 'information_resources',
                verbose: 'Кількість е-ресурсів',
            }, {
                code: 'interfaces',
                verbose: 'Кількість інтерфейсів',
            }, {
                code: 'subsystems',
                verbose: 'Кількість підсистем',
            }, {
                code: 'services',
                verbose: 'Кількість сервісів',
            }, {
                code: 'interactions',
                verbose: 'Кількість взаємодій',
            }]
    },
    organization: {
        list: {
            endpoints: {
                list: ":backend_url/api/v1/directory/organization/",
            },
            items: [
                {
                    text: 'Назва організації',
                    align: 'start',
                    value: 'name',
                    class: 'data-table-header',
                    width: "250px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Код ЄДРПОУ', 
                    value: 'member_code', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "130px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Дата реєстрації', 
                    value: 'date', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "150px",
                    sortable: false,
                    searchable: false,
                    default: true,
                },
            ],
        },
        filters: {
            items: [
                {
                    name: 'Дата реєстрації',
                    code: 'registered_at',
                    type: 'daterange',
                },
                {
                    name: 'Тип організації',
                    code: 'organization_type',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=organization_type',
                },
                {
                    name: 'Статус інтеграції з системою',
                    code: 'organization_intergration_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=organization_intergration_status',
                },
                {
                    name: 'Статус обміну даними через інтерфейси',
                    code: 'data_exchange_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=data_exchange_status',
                },
                {
                    name: 'Статус (Активна/Архівна)',
                    code: 'object_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=object_status',
                },
            ]
        },
        analytics: {
            endpoints: {
                issues: ":backend_url/api/v1/directory/organization/:id/analytics",
            },
            display: {
                general_overview: [{
                        code: 'total_service_count',
                        type: 'string',
                        verbose: 'Всього сервісів'
                    }, {
                        code: 'displayed_eresources',
                        type: 'string',
                        verbose: 'Всього е-ресурсів'
                    }, {
                        code: 'displayed_subsystems',
                        type: 'string',
                        verbose: 'Всього підсистем'
                    }, {
                        code: 'service_with_interface_percent',
                        type: 'three-colored-percent',
                        verbose: 'Відсоток сервісів, що мають опис'
                    }, {
                        code: 'updated_eresources_percent',
                        type: 'three-colored-percent',
                        verbose: 'Відсоток е-ресурсів з оновленими даними'
                    }, {
                        code: 'subsystems_with_eresources_percent',
                        type: 'three-colored-percent',
                        verbose: 'Відсоток підсистем, що мають прикріплені е-ресурси'
                }],
                general_issues_stats: [{
                        code: 'no_interface_service_count',
                        type: 'string',
                        verbose: 'Сервісів без інтерфейсу е-ресурсу'
                    }, {
                        code: 'not_updated_eresources',
                        type: 'string',
                        verbose: 'Е-ресурсів без опису'
                    }, {
                        code: 'subsystems_without_eresources',
                        type: 'string',
                        verbose: 'Підсистем не закріплених за е-ресурсами'
                }],
                detailed_issues_description: [{
                        text: 'Об\'єкт',
                        align: 'start',
                        value: 'object_type',
                        class: 'data-table-detail-header',
                    }, { 
                        text: 'Назва',
                        align: 'start',
                        value: 'object_name', 
                        class: 'data-table-detail-header',
                    }, { 
                        text: 'Опис проблеми',
                        align: 'start',
                        value: 'fix_description', 
                        class: 'data-table-detail-header',
                }],
            }
        },
        detail: {
            endpoints: {
                detail: ":backend_url/api/v1/directory/organization/:id/",
                metadata: ":backend_url/api/v1/directory/organization/:id/metadata",
                secure_metadata: ":backend_url/api/v1/directory/organization/:id/secure_metadata",
                information_resources: ":backend_url/api/v1/directory/organization/:id/information_resources",
                subsystems: ":backend_url/api/v1/directory/organization/:id/subsystems",
                interfaces: ":backend_url/api/v1/directory/organization/:id/interfaces",
                services: ":backend_url/api/v1/directory/organization/:id/services",
                interactions: ":backend_url/api/v1/directory/organization/:id/interactions",
            },
            display: {
                information_resources: [{
                    text: 'Назва е-ресурсу',
                    align: 'start',
                    value: 'name',
                    class: 'data-table-detail-header fifty-width',
                }, { 
                    text: 'Роль',
                    align: 'start',
                    value: 'role', 
                    class: 'data-table-detail-header fifty-width',
                }],
                subsystems: [{
                    text: 'Код підсистеми',
                    align: 'start',
                    value: 'subsystem_code',
                    class: 'data-table-detail-header fifty-width',
                }, { 
                    text: 'Інформаційний е-ресурс',
                    align: 'start',
                    value: 'information_resource', 
                    class: 'data-table-detail-header fifty-width',
                }],
                interfaces: [{
                    text: 'Назва інтерфейсу',
                    align: 'start',
                    value: 'name',
                    class: 'data-table-detail-header fifty-width',
                }, { 
                    text: 'Інформаційний е-ресурс',
                    value: 'information_resource', 
                    align: 'start',
                    class: 'data-table-detail-header fifty-width',
                }],
                services: [{
                    text: 'Код сервісу',
                    align: 'start',
                    value: 'service_code',
                    class: 'data-table-detail-header fifty-width',
                },{ 
                    text: 'Назва сервісу',
                    align: 'start',
                    value: 'name', 
                    class: 'data-table-detail-header fifty-width',
                }],
                interactions: [{
                    text: 'Назва організації (вебсервіс)',
                    align: 'start',
                    value: 'producer_organization',
                    class: 'data-table-detail-header data-table-date-col-width',
                }, { 
                    text: 'Е-ресурс (вебсервіс)',
                    align: 'start',
                    value: 'producer_information_resource', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Інтерфейс е-ресурсу (вебсервіс)',
                    align: 'start',
                    value: 'producer_interface', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Назва організації (вебклієнт)',
                    align: 'start',
                    value: 'consumer_organization', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Е-ресурс (вебклієнт)',
                    align: 'start',
                    value: 'consumer_information_resource', 
                    class: 'data-table-detail-header',
                }],
            },
            items: [{
                code: 'id',
                display: false,
            }, {
                code: 'name',
                type: 'string',
                verbose: 'Назва організації'
            }, {
                code: 'member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ'
            }, {
                code: 'registered_at',
                type: 'date',
                verbose: 'Дата реєстрації'
            }, {
                code: 'organization_type',
                type: 'string',
                verbose: 'Тип організації'
            }, {
                code: 'integration_status_test',
                type: 'string',
                display_prod: false,
                verbose: 'Статус інтеграції з системою'
            }, {
                code: 'integration_status_prod',
                type: 'string',
                display_test: false,
                verbose: 'Статус інтеграції з системою'
            }, {
                code: 'data_exchange_status_test',
                type: 'string',
                display_prod: false,
                verbose: 'Статус обміну даними через інтерфейси'
            }, {
                code: 'data_exchange_status_prod',
                type: 'string',
                display_test: false,
                verbose: 'Статус обміну даними через інтерфейси'
            }, {
                code: 'is_deleted',
                type: 'string',
                verbose: 'Статус (Активна/В архіві)'
            }]
        }
    },
    information_resource: {
        filters: {
            items: [
                {
                    name: 'Дата підключення до системи (у відповідному середовищі)',
                    code: 'registered_at',
                    type: 'daterange',
                },
                {
                    name: 'Тип інтеграції з системою через інтерфейси',
                    code: 'data_exchange_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=data_exchange_status',
                },
                {
                    name: 'Статус (Активна/Архівна)',
                    code: 'object_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=object_status',
                },
                {
                    name: 'За наявністю підсистем у відповідному середовищі',
                    code: 'display_active',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=display_active',
                },
            ]
        },
        list: {
            endpoints: {
                list: ":backend_url/api/v1/directory/information_resource/",
            },
            items: [
                {
                  text: 'Назва е-ресурсу',
                  align: 'start',
                  value: 'name',
                  class: 'data-table-header',
                  width: "550px",
                  sortable: false,
                  searchable: true,
                  default: true,
                },
                { 
                  text: 'Власник е-ресурсу', 
                  value: 'owner__name', 
                  align: 'start',
                  class: 'data-table-header',
                  width: "310px",
                  sortable: false,
                  searchable: true,
                  default: true,
                },
                { 
                  text: 'Код ЄДРПОУ', 
                  value: 'owner__member_code', 
                  align: 'start',
                  class: 'data-table-header data-table-date-col-width',
                  sortable: false,
                  searchable: true,
                  default: true,
                },  
            ]
        },
        detail: {
            endpoints: {
                detail: ":backend_url/api/v1/directory/information_resource/:id/",
                subsystems: ":backend_url/api/v1/directory/information_resource/:id/subsystems",
                interfaces: ":backend_url/api/v1/directory/information_resource/:id/interfaces",
                services: ":backend_url/api/v1/directory/information_resource/:id/services",
                interactions: ":backend_url/api/v1/directory/information_resource/:id/interactions",
            },
            display: {
                subsystems: [{
                    text: 'Код підсистеми',
                    align: 'start',
                    value: 'subsystem_code',
                    class: 'data-table-detail-header',
                }],
                interfaces: [{
                    text: 'Назва інтерфейсу',
                    align: 'start',
                    value: 'name',
                    class: 'data-table-detail-header',
                }],
                services: [{
                    text: 'Код сервісу',
                    align: 'start',
                    value: 'service_code',
                    class: 'data-table-detail-header fifty-width',
                },{ 
                    text: 'Назва сервісу',
                    align: 'start',
                    value: 'name', 
                    class: 'data-table-detail-header fifty-width',
                }],
                interactions: [{
                    text: 'Назва організації (вебсервіс)',
                    align: 'start',
                    value: 'producer_organization',
                    class: 'data-table-detail-header data-table-date-col-width',
                }, { 
                    text: 'Е-ресурс (вебсервіс)',
                    align: 'start',
                    value: 'producer_information_resource', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Інтерфейс е-ресурсу (вебсервіс)',
                    align: 'start',
                    value: 'producer_interface', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Назва організації (вебклієнт)',
                    align: 'start',
                    value: 'consumer_organization', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Е-ресурс (вебклієнт)',
                    align: 'start',
                    value: 'consumer_information_resource', 
                    class: 'data-table-detail-header',
                }],
            },
            items: [{
                code: 'id',
                display: false,
            }, {
                code: 'name',
                type: 'string',
                verbose: 'Назва е-ресурсу'
            }, {
                code: 'description',
                type: 'string',
                verbose: 'Опис е-ресурсу'
            }, {
                code: 'owner',
                display: false,
            }, {
                code: 'owner_name',
                type: 'routed',
                route_id_field: 'owner',
                route_type: 'org',
                verbose: 'Власник',
            }, {
                code: 'owner_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ власника'
            }, {
                code: 'nreir_identifier',
                type: 'string',
                verbose: 'Реєстраційний номер е-ресурсу в НРЕІР'
            }, {
                code: 'nreir_link',
                type: 'link',
                verbose: 'Посилання на е-ресурс в НРЕІР'
            }, {
                code: 'data_exchange_status_test',
                type: 'string',
                display_prod: false,
                verbose: 'Тип інтеграції з системою через інтерфейси'
            }, {
                code: 'data_exchange_status_prod',
                type: 'string',
                display_test: false,
                verbose: 'Тип інтеграції з системою через інтерфейси'
            }, {
                code: 'sevdeir_registered_at_test',
                type: 'date',
                display_prod: false,
                verbose: 'Дата підключення до системи (у відповідному середовищі)'
            }, {
                code: 'sevdeir_registered_at_prod',
                type: 'date',
                display_test: false,
                verbose: 'Дата підключення до системи (у відповідному середовищі)'
            }, {
                code: 'first_exchange_at_test',
                type: 'date',
                display_prod: false,
                verbose: 'Дата першого обміну'
            }, {
                code: 'first_exchange_at_prod',
                type: 'date',
                display_test: false,
                verbose: 'Дата першого обміну'
            }, {
                code: 'operator_1',
                display: false,
            }, {
                code: 'operator_1_name',
                type: 'routed',
                route_id_field: 'operator_1',
                route_type: 'org',
                verbose: 'Оператор 1',
            }, {
                code: 'operator_1_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ оператора 1'
            }, {
                code: 'operator_1_status_verbose',
                type: 'string',
                verbose: 'Статус повноважень оператора 1'
            }, {
                code: 'operator_2',
                display: false,
            }, {
                code: 'operator_2_name',
                type: 'routed',
                route_id_field: 'operator_2',
                route_type: 'org',
                verbose: 'Оператор 2',
            }, {
                code: 'operator_2_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ оператора 2'
            }, {
                code: 'operator_2_status_verbose',
                type: 'string',
                verbose: 'Статус повноважень оператора 2'
            }, {
                code: 'operator_3',
                display: false,
            }, {
                code: 'operator_3_name',
                type: 'routed',
                route_id_field: 'operator_3',
                route_type: 'org',
                verbose: 'Оператор 3',
            }, {
                code: 'operator_3_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ оператора 3'
            }, {
                code: 'operator_3_status_verbose',
                type: 'string',
                verbose: 'Статус повноважень оператора 3'
            }, {
                code: 'operator_4',
                display: false,
            }, {
                code: 'operator_4_name',
                type: 'routed',
                route_id_field: 'operator_4',
                route_type: 'org',
                verbose: 'Оператор 4',
            }, {
                code: 'operator_4_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ оператора 4'
            }, {
                code: 'operator_4_status_verbose',
                type: 'string',
                verbose: 'Статус повноважень оператора 4'
            }, {
                code: 'operator_5',
                display: false,
            }, {
                code: 'operator_5_name',
                type: 'routed',
                route_id_field: 'operator_5',
                route_type: 'org',
                verbose: 'Оператор 5',
            }, {
                code: 'operator_5_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ оператора 5'
            }, {
                code: 'operator_5_status_verbose',
                type: 'string',
                verbose: 'Статус повноважень оператора 5'
            }, {
                code: 'operator_6',
                display: false,
            }, {
                code: 'operator_6_name',
                type: 'routed',
                route_id_field: 'operator_6',
                route_type: 'org',
                verbose: 'Оператор 6',
            }, {
                code: 'operator_6_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ оператора 6'
            }, {
                code: 'operator_6_status_verbose',
                type: 'string',
                verbose: 'Статус повноважень оператора 6'
            }, {
                code: 'is_deleted',
                type: 'string',
                verbose: 'Статус (Активна/В архіві)'
            }]
        }
    }, 
    subsystem: {
        filters: {
            items: [
                {
                    name: 'Дата реєстрації',
                    code: 'registered_at',
                    type: 'daterange',
                },
                {
                    name: 'Статус (Активна/Архівна)',
                    code: 'object_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=object_status',
                },
                {
                    name: 'Належить до е-ресурсу',
                    code: 'has_information_resource',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=boolean_choice',
                },
            ]
        },
        list: {
            endpoints: {
                list: ":backend_url/api/v1/directory/subsystem/",
            }, 
            items: [
                {
                    text: 'Код підсистеми',
                    align: 'start',
                    value: 'subsystem_code',
                    class: 'data-table-header',
                    width: "200px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Назва е-ресурсу', 
                    value: 'information_eresource__name', 
                    align: 'start',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Власник підсистеми', 
                    value: 'owner__name', 
                    align: 'start',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Код власника', 
                    value: 'owner__member_code', 
                    align: 'start',
                    class: 'data-table-header data-table-date-col-width',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Статус',
                    value: 'is_deleted', 
                    align: 'start',
                    class: 'data-table-header',
                    width: '120px',
                    sortable: false,
                    searchable: false,
                    default: true,
                },
            ]
        },
        detail: {
            endpoints: {
                detail: ":backend_url/api/v1/directory/subsystem/:id/",
                interfaces: ":backend_url/api/v1/directory/subsystem/:id/interfaces",
                services: ":backend_url/api/v1/directory/subsystem/:id/services",
                interactions: ":backend_url/api/v1/directory/subsystem/:id/interactions",
            },
            display: {
                interfaces: [{
                    text: 'Назва інтерфейсу',
                    align: 'start',
                    value: 'name',
                    class: 'data-table-detail-header',
                }],
                services: [{
                    text: 'Код сервісу',
                    align: 'start',
                    value: 'service_code',
                    class: 'data-table-detail-header fifty-width',
                }, { 
                    text: 'Назва сервісу',
                    align: 'start',
                    value: 'name', 
                    class: 'data-table-detail-header fifty-width',
                }],
                interactions: [{
                    text: 'Назва організації (вебсервіс)',
                    align: 'start',
                    value: 'producer_organization',
                    class: 'data-table-detail-header data-table-date-col-width',
                }, { 
                    text: 'Е-ресурс (вебсервіс)',
                    align: 'start',
                    value: 'producer_information_resource', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Інтерфейс е-ресурсу (вебсервіс)',
                    align: 'start',
                    value: 'producer_interface', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Назва організації (вебклієнт)',
                    align: 'start',
                    value: 'consumer_organization', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Е-ресурс (вебклієнт)',
                    align: 'start',
                    value: 'consumer_information_resource', 
                    class: 'data-table-detail-header',
                }],
            },
            items: [{
                code: 'id',
                display: false,
            }, {
                code: 'subsystem_code',
                type: 'string',
                verbose: 'Код підсистеми'
            }, {
                code: 'owner',
                display: false,
            }, {
                code: 'owner_name',
                type: 'routed',
                route_id_field: 'owner',
                route_type: 'org',
                verbose: 'Власник',
            }, {
                code: 'owner_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ власника'
            }, {
                code: 'information_resource',
                display: false,
            }, {
                code: 'information_resource_name',
                type: 'routed',
                route_id_field: 'information_resource',
                route_type: 'irs',
                verbose: 'Назва е-ресурсу',
            },{
                code: 'full_sevdeir_identifier',
                type: 'string',
                verbose: 'Повний ідентифікатор підсистеми'
            },{
                code: 'created_at',
                type: 'date',
                verbose: 'Дата реєстрації'
            }, {
                code: 'is_deleted',
                type: 'string',
                verbose: 'Статус (Активна/В архіві)'
            }]
        }
    }, 
    information_resource_interface: {
        filters: {
            items: [
                {
                    name: 'Дата створення інтерфейсу е-ресурсу',
                    code: 'registered_at',
                    type: 'daterange',
                },
                {
                    name: 'Статус (Активна/Архівна)',
                    code: 'object_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=object_status',
                },
                {
                    name: 'Тип інтерфейсу е-ресурсу',
                    code: 'exchange_data_type',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=exchange_data_type',
                },
                {
                    name: 'Обмеження щодо використання',
                    code: 'has_usage_restrictions',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=boolean_choice',
                },
                {
                    name: 'Публічний інтерфейс',
                    code: 'is_public',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=boolean_choice',
                },
                {
                    name: 'Обробка персональних даних інтерфейсом е-ресурсу',
                    code: 'has_personal_data_processing',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=boolean_choice',
                },
                {
                    name: 'За наявністю основних сервісів у відповідному середовищі',
                    code: 'display_active',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=display_active',
                },
            ]
        },
        list: {
            endpoints: {
                list: ":backend_url/api/v1/directory/interface/",
            },
            items: [
                {
                    text: 'Назва інтерфейсу',
                    value: 'name',
                    align: 'start',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Назва е-ресурсу', 
                    value: 'information_eresource__name', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "300px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Власник інтерфейсу', 
                    value: 'owner__name', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "300px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Код ЄДРПОУ', 
                    value: 'owner__member_code', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "120px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Дата створення', 
                    value: 'registered_at', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "120px",
                    sortable: false,
                    searchable: false,
                    default: true,
                },
            ],
        },
        detail: {
            endpoints: {
                detail: ":backend_url/api/v1/directory/interface/:id/",
                authenticated_detail: ":backend_url/api/v1/directory/interface/:id",
                documentation: ":backend_url/api/v1/directory/interface/:id/documentation",
                services: ":backend_url/api/v1/directory/interface/:id/services",
                interactions: ":backend_url/api/v1/directory/interface/:id/interactions",
            },
            restrictions: {
                documentation: {
                    auth_required: false,
                }
            },
            display: {
                documentation: [{
                    align: 'start',
                    value: 'name',
                    class: 'data-table-detail-header',
                }, { 
                    align: 'start',
                    value: 'document_type',
                    class: 'data-table-detail-header data-table-date-col-width',
                }, { 
                    align: 'start',
                    value: 'updated_at',
                    class: 'data-table-detail-header data-table-date-col-width',
                }, { 
                    align: 'center',
                    value: 'document',
                    class: 'data-table-detail-header data-table-date-col-width',
                }],
                services: [{
                    text: 'Код сервісу',
                    align: 'start',
                    value: 'service_code',
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Назва сервісу',
                    align: 'start',
                    value: 'name', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Роль сервісу',
                    align: 'start',
                    value: 'service_role', 
                    class: 'data-table-detail-header',
                }],
                interactions: [{
                    text: 'Назва організації (вебсервіс)',
                    align: 'start',
                    value: 'producer_organization',
                    class: 'data-table-detail-header data-table-date-col-width',
                }, { 
                    text: 'Е-ресурс (вебсервіс)',
                    align: 'start',
                    value: 'producer_information_resource', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Інтерфейс е-ресурсу (вебсервіс)',
                    align: 'start',
                    value: 'producer_interface', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Назва організації (вебклієнт)',
                    align: 'start',
                    value: 'consumer_organization', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Е-ресурс (вебклієнт)',
                    align: 'start',
                    value: 'consumer_information_resource', 
                    class: 'data-table-detail-header',
                }],
            },
            items: [{
                code: 'id',
                display: false,
            }, {
                code: 'name',
                type: 'string',
                verbose: 'Назва інтерфейсу е-ресурсу'
            }, {
                code: 'owner',
                display: false,
            }, {
                code: 'owner_name',
                type: 'routed',
                route_id_field: 'owner',
                route_type: 'org',
                verbose: 'Назва організації',
            }, {
                code: 'owner_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ'
            }, {
                code: 'information_resource',
                display: false,
            }, {
                code: 'information_resource_name',
                type: 'routed',
                route_id_field: 'information_resource',
                route_type: 'irs',
                verbose: 'Назва е-ресурсу',
            },{
                code: 'registered_at',
                type: 'date',
                verbose: 'Дата створення інтерфейсу е-ресурсу'
            },{
                code: 'services_description',
                type: 'string',
                verbose: 'Скорочені коди сервісів, що формують інтерфейс е-ресурсу'
            },{
                code: 'services_call_sequence_description',
                type: 'string',
                verbose: 'Послідовність виклику сервісів',
                auth_required: false,
            },{
                code: 'description',
                type: 'string',
                verbose: 'Опис призначення'
            },{
                code: 'exchange_data_type',
                type: 'string',
                verbose: 'Тип інтерфейсу е-ресурсу'
            },{
                code: 'usage_restrictions',
                type: 'string',
                verbose: 'Обмеження щодо використання'
            },{
                code: 'is_public',
                type: 'boolean',
                verbose: 'Публічний інтерфейс'
            },{
                code: 'personal_data_processing',
                type: 'boolean',
                verbose: 'Обробка персональних даних інтерфейсом е-ресурсу'
            }, {
                code: 'is_deleted',
                type: 'string',
                verbose: 'Статус (Активна/В архіві)'
            }]
        }
    }, 
    service: {
        filters: {
            items: [
                {
                    name: 'Дата публікації в каталозі',
                    code: 'published_at',
                    type: 'daterange',
                },
                {
                    name: 'Статус (Активна/Архівна)',
                    code: 'object_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=object_status',
                },
                {
                    name: 'Протокол роботи',
                    code: 'service_protocol',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=service_protocol',
                },
                {
                    name: 'Роль сервісу',
                    code: 'service_role',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=service_role',
                },
            ]
        },
        list: {
            endpoints: {
                list: ":backend_url/api/v1/directory/service/",
            },
            items: [
                {
                    text: 'Назва сервісу',
                    align: 'start',
                    value: 'name',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                    // width: "300px",
                },
                {
                    text: 'Код сервісу',
                    align: 'start',
                    value: 'service_code',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                    // width: "300px",
                },
                {
                    text: 'Інтерфейси е-ресурсу',
                    align: 'start',
                    value: 'interfaces_name',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                    // width: "300px",
                },
                {
                    text: 'Назва е-ресурсу',
                    align: 'start',
                    value: 'subsystem__information_eresource__name',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                    // width: "300px",
                },
                {
                    text: 'Підсистема',
                    align: 'start',
                    value: 'subsystem__subsystem_code',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                    // width: "300px",
                },
                { 
                    text: 'Назва організації', 
                    value: 'organization__name', 
                    align: 'start',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                    // width: "300px",
                },
                {
                    text: 'Код ЄДРПОУ', 
                    value: 'organization__member_code', 
                    align: 'start',
                    class: 'data-table-header data-table-date-col-width',
                    sortable: false,
                    searchable: true,
                    default: true,
                    width: "80px",
                },
                {
                    text: 'Статус', 
                    value: 'is_deleted', 
                    align: 'start',
                    class: 'data-table-header data-table-date-col-width',
                    sortable: false,
                    searchable: false,
                    default: true,
                    width: "135px",
                },
            ]
        },
        detail: {
            endpoints: {
                detail: ":backend_url/api/v1/directory/service/:id/",
                authenticated_detail: ":backend_url/api/v1/directory/service/:id/authenticated_details",
                stats: ":backend_url/api/v1/directory/service/:id/stats",
            },
            display: {},
            items: [{
                code: 'id',
                display: false,
            }, {
                code: 'name',
                type: 'string',
                verbose: 'Назва сервісу'
            }, {
                code: 'owner',
                display: false,
            }, {
                code: 'owner_name',
                type: 'routed',
                route_id_field: 'owner',
                route_type: 'org',
                verbose: 'Назва організації',
            }, {
                code: 'owner_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ'
            }, {
                code: 'information_resource',
                display: false,
            }, {
                code: 'information_resource_name',
                type: 'routed',
                route_id_field: 'information_resource',
                route_type: 'irs',
                verbose: 'Е-ресурс',
            }, {
                code: 'subsystem',
                display: false,
            }, {
                code: 'subsystem_code',
                type: 'routed',
                route_id_field: 'subsystem',
                route_type: 'sub',
                verbose: 'Підсистема',
            }, {
                code: 'created_at',
                type: 'date',
                verbose: 'Дата публікації в каталозі'
            },{
                code: 'service_code',
                type: 'string',
                verbose: 'Код сервісу'
            },{
                code: 'service_type',
                type: 'string',
                verbose: 'Протокол роботи'
            },{
                code: 'full_sevdeir_identifier',
                type: 'string',
                verbose: 'Повний ідентифікатор сервісу в просторі СЕВДЕІР'
            },{
                code: 'service_role',
                type: 'string',
                verbose: 'Роль сервісу'
            },{
                code: 'interfaces_name',
                type: 'string',
                verbose: 'Інтерфейси е-ресурсу'
            },{
                code: 'current_wsdl_link',
                type: 'file',
                verbose: 'WSDL сервісу',
                auth_required: false,
            },{
                code: 'current_wsdl_updated_at',
                type: 'date',
                verbose: 'Дата оновлення WSDL',
            }, {
                code: 'is_deleted',
                type: 'string',
                verbose: 'Статус (Активна/В архіві)'
            }]
        }
    },
    interaction: {
        filters: {
            items: [
                {
                    name: 'Дата початку взаємодії',
                    code: 'first_request_datetime',
                    type: 'daterange',
                },
                {
                    name: 'Статус (Активна/Архівна)',
                    code: 'object_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=object_status',
                },
                {
                    name: 'Постачальник/Отримувач',
                    code: 'exchange_data_type',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=exchange_data_type',
                },
                {
                    name: 'Назва організації (вебклієнт)',
                    code: 'client_organization_list',
                    type: 'multiselectsearch',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=organization_list',
                },
                {
                    name: 'Е-ресурс (вебклієнт)',
                    code: 'client_information_resources_list',
                    type: 'multiselectsearch',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=information_resources_list',
                },
                {
                    name: 'Назва організації (вебсервіс)',
                    code: 'service_organization_list',
                    type: 'multiselectsearch',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=organization_list',
                },
                {
                    name: 'Е-ресурс (вебсервіс)',
                    code: 'service_information_resources_list',
                    type: 'multiselectsearch',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=information_resources_list',
                },
                {
                    name: 'Інтерфейс е-ресурсу (вебсервіс)',
                    code: 'service_interfaces_list',
                    type: 'multiselectsearch',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=interfaces_list',
                },
                {
                    name: 'За наявністю обмінів у відповідному середовищі',
                    code: 'display_active',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=display_active',
                },
            ]
        },
        list: {
            endpoints: {
                list: ":backend_url/api/v1/directory/interaction/",
            },
            items: [
                {
                    text: 'Назва організації (вебклієнт)',
                    align: 'start',
                    value: 'consumer_organization__name',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                {
                    text: 'Код ЄДРПОУ (вебклієнт)',
                    align: 'start',
                    value: 'consumer_organization__member_code',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                {
                    text: 'Е-ресурс (вебклієнт)',
                    align: 'start',
                    value: 'consumer_information_resource__name',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                {
                    text: 'Назва організації (вебсервіс)',
                    align: 'start',
                    value: 'producer_organization__name',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                {
                    text: 'Код ЄДРПОУ (вебсервіс)',
                    align: 'start',
                    value: 'producer_organization__member_code',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Е-ресурс (вебсервіс)', 
                    value: 'producer_information_resource__name', 
                    align: 'start',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Інтерфейс е-ресурсу (вебсервіс)', 
                    value: 'producer_interface__name', 
                    align: 'start',
                    class: 'data-table-header',
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                {
                    text: 'Статус', 
                    value: 'is_deleted', 
                    align: 'start',
                    class: 'data-table-header data-table-date-col-width',
                    default: true,
                },
            ]
        },
        detail: {
            endpoints: {
                detail: ":backend_url/api/v1/directory/interaction/:id/",
                exchanges: ":backend_url/api/v1/directory/interaction/:id/exchanges",
            },
            display: {
                exchanges: [{
                    text: 'Сервіс (вебсервіс)',
                    align: 'start',
                    value: 'service_identifier',
                    class: 'data-table-detail-header data-table-date-col-width',
                }, { 
                    text: 'Підсистема (вебклієнт)',
                    align: 'start',
                    value: 'subsystem_identifier', 
                    class: 'data-table-detail-header',
                }, { 
                    text: 'Роль сервісу',
                    align: 'start',
                    value: 'service_role', 
                    class: 'data-table-detail-header',
                },],
            },
            items: [{
                code: 'id',
                display: false,
            }, {
                code: 'producer_organization',
                display: false,
            }, {
                code: 'producer_organization_name',
                type: 'routed',
                route_id_field: 'producer_organization',
                route_type: 'org',
                verbose: 'Назва організації (вебсервіс)',
            }, {
                code: 'producer_organization_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ (вебсервіс)'
            }, {
                code: 'producer_information_resource',
                display: false,
            }, {
                code: 'producer_information_resource_name',
                type: 'routed',
                route_id_field: 'producer_information_resource',
                route_type: 'irs',
                verbose: 'Е-ресурс (вебсервіс)',
            }, {
                code: 'producer_interface',
                display: false,
            }, {
                code: 'producer_interface_name',
                type: 'routed',
                route_id_field: 'producer_interface',
                route_type: 'intf',
                verbose: 'Інтерфейс е-ресурсу (вебсервіс)',
            }, {
                code: 'consumer_organization',
                display: false,
            }, {
                code: 'consumer_organization_name',
                type: 'routed',
                route_id_field: 'consumer_organization',
                route_type: 'org',
                verbose: 'Назва організації (вебклієнт)',
            }, {
                code: 'consumer_organization_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ (вебклієнт)'
            }, {
                code: 'consumer_information_resource',
                display: false,
            }, {
                code: 'consumer_information_resource_name',
                type: 'routed',
                route_id_field: 'consumer_information_resource',
                route_type: 'irs',
                verbose: 'Е-ресурс (вебклієнт)',
            }, {
                code: 'interface_type',
                type: 'string',
                verbose: 'Постачальник/Отримувач'
            }, {
                code: 'first_request_datetime_at_test',
                type: 'date',
                verbose: 'Дата початку взаємодії',
                display_prod: false,
            }, {
                code: 'first_request_datetime_at_prod',
                type: 'date',
                verbose: 'Дата початку взаємодії',
                display_test: false,
            }, {
                code: 'is_deleted',
                type: 'string',
                verbose: 'Статус (Активна/В архіві)'
            }]
        }
    },
    server: {
        list: {
            endpoints: {
                list: ":backend_url/api/v1/directory/server/",
            },
            items: [
                {
                    text: 'Код шлюзу',
                    align: 'start',
                    value: 'server_code',
                    class: 'data-table-header',
                    width: "250px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Назва власника', 
                    value: 'owner__name', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "130px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Код ЄДРПОУ власника', 
                    value: 'owner__member_code', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "150px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                {
                    text: 'Адреса ШБО',
                    align: 'start',
                    value: 'address',
                    class: 'data-table-header',
                    width: "250px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Версія ШБО', 
                    value: 'package_version', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "130px",
                    sortable: false,
                    searchable: true,
                    default: true,
                },
                { 
                    text: 'Статус реєстрації', 
                    value: 'is_deleted', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "150px",
                    sortable: false,
                    searchable: false,
                    default: true,
                },
                {
                    text: 'Останній статус', 
                    value: 'annotated_last_central_request_status', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "150px",
                    sortable: false,
                    searchable: false,
                    default: true,
                },
                { 
                    text: 'Дата останнього оновлення', 
                    value: 'annotated_last_central_request_at', 
                    align: 'start',
                    class: 'data-table-header',
                    width: "150px",
                    sortable: false,
                    searchable: false,
                    default: true,
                },
            ],
        },
        filters: {
            items: [
                // {
                //     name: 'Дата реєстрації',
                //     code: 'registered_at',
                //     type: 'daterange',
                // },
                {
                    name: 'Статус (Активна/Архівна)',
                    code: 'object_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=object_status',
                },
                {
                    name: 'За взаємозв\'язком',
                    code: 'security_server_relationship',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=security_server_relationship',
                },
                {
                    name: 'За статусом ШБО від центрального моніторингу Каталогу',
                    code: 'security_server_status',
                    type: 'multiselect',
                    values_source: 'external',
                    endpoint: '/api/v1/directory/filters/?filter_name=security_server_status',
                },
                // {
                //     name: 'Тип організації',
                //     code: 'organization_type',
                //     type: 'multiselect',
                //     values_source: 'external',
                //     endpoint: '/api/v1/directory/filters/?filter_name=organization_type',
                // },
                // {
                //     name: 'Статус інтеграції з системою',
                //     code: 'organization_intergration_status',
                //     type: 'multiselect',
                //     values_source: 'external',
                //     endpoint: '/api/v1/directory/filters/?filter_name=organization_intergration_status',
                // },
                // {
                //     name: 'Статус обміну даними через інтерфейси',
                //     code: 'data_exchange_status',
                //     type: 'multiselect',
                //     values_source: 'external',
                //     endpoint: '/api/v1/directory/filters/?filter_name=data_exchange_status',
                // },
                // {
                //     name: 'Статус (Активна/Архівна)',
                //     code: 'object_status',
                //     type: 'multiselect',
                //     values_source: 'external',
                //     endpoint: '/api/v1/directory/filters/?filter_name=object_status',
                // },
            ]
        },
        detail: {
            endpoints: {
                detail: ":backend_url/api/v1/directory/server/:id/",
                subsystems: ":backend_url/api/v1/directory/server/:id/subsystems",
                services: ":backend_url/api/v1/directory/server/:id/services",
                certificates: ":backend_url/api/v1/directory/server/:id/certificates",
                // information_resources: ":backend_url/api/v1/directory/organization/:id/information_resources",
                // subsystems: ":backend_url/api/v1/directory/organization/:id/subsystems",
                // interfaces: ":backend_url/api/v1/directory/organization/:id/interfaces",
                // services: ":backend_url/api/v1/directory/organization/:id/services",
                // interactions: ":backend_url/api/v1/directory/organization/:id/interactions",
            },
            display: {
                // information_resources: [{
                //     text: 'Назва е-ресурсу',
                //     align: 'start',
                //     value: 'name',
                //     class: 'data-table-detail-header fifty-width',
                // }, { 
                //     text: 'Роль',
                //     align: 'start',
                //     value: 'role', 
                //     class: 'data-table-detail-header fifty-width',
                // }],
                subsystems: [{
                    text: 'Код підсистеми',
                    align: 'start',
                    value: 'subsystem_code',
                    class: 'data-table-detail-header fifty-width',
                }, { 
                    text: 'Інформаційний е-ресурс',
                    align: 'start',
                    value: 'information_resource', 
                    class: 'data-table-detail-header fifty-width',
                }],
                // interfaces: [{
                //     text: 'Назва інтерфейсу',
                //     align: 'start',
                //     value: 'name',
                //     class: 'data-table-detail-header fifty-width',
                // }, { 
                //     text: 'Інформаційний е-ресурс',
                //     value: 'information_resource', 
                //     align: 'start',
                //     class: 'data-table-detail-header fifty-width',
                // }],
                services: [{
                    text: 'Код сервісу',
                    align: 'start',
                    value: 'service_code',
                    class: 'data-table-detail-header fifty-width',
                },{ 
                    text: 'Назва сервісу',
                    align: 'start',
                    value: 'name', 
                    class: 'data-table-detail-header fifty-width',
                }],
                certificates: [{
                    text: 'Тип сертифікату',
                    align: 'start',
                    value: 'type',
                    class: 'data-table-detail-header',
                },{ 
                    text: 'Видавець',
                    align: 'start',
                    value: 'issued_by', 
                    class: 'data-table-detail-header',
                },{ 
                    text: 'Діє до',
                    align: 'start',
                    value: 'not_after', 
                    class: 'data-table-detail-header',
                },{ 
                    text: 'ОЦСП сервер',
                    align: 'start',
                    value: 'ocsp_uri', 
                    class: 'data-table-detail-header',
                },{ 
                    text: 'Сертифікат',
                    align: 'start',
                    value: 'cert', 
                    class: 'data-table-detail-header',
                }],
                // interactions: [{
                //     text: 'Назва організації (вебсервіс)',
                //     align: 'start',
                //     value: 'producer_organization',
                //     class: 'data-table-detail-header data-table-date-col-width',
                // }, { 
                //     text: 'Е-ресурс (вебсервіс)',
                //     align: 'start',
                //     value: 'producer_information_resource', 
                //     class: 'data-table-detail-header',
                // }, { 
                //     text: 'Інтерфейс е-ресурсу (вебсервіс)',
                //     align: 'start',
                //     value: 'producer_interface', 
                //     class: 'data-table-detail-header',
                // }, { 
                //     text: 'Назва організації (вебклієнт)',
                //     align: 'start',
                //     value: 'consumer_organization', 
                //     class: 'data-table-detail-header',
                // }, { 
                //     text: 'Е-ресурс (вебклієнт)',
                //     align: 'start',
                //     value: 'consumer_information_resource', 
                //     class: 'data-table-detail-header',
                // }],
            },
            items: [{
                code: 'id',
                display: false,
            }, {
                code: 'server_code',
                type: 'string',
                verbose: 'Код ШБО'
            }, {
                code: 'owner',
                type: 'string',
                display: false,
                verbose: 'Власник'
            }, {
                code: 'owner_name',
                type: 'string',
                verbose: 'Власник'
            }, {
                code: 'owner_member_code',
                type: 'string',
                verbose: 'Код ЄДРПОУ власника'
            }, {
                code: 'address',
                type: 'string',
                verbose: 'Адреса ШБО'
            }, {
                code: 'package_version',
                type: 'string',
                verbose: 'Версія ШБО'
            }, {
                code: 'created_at',
                type: 'date',
                verbose: 'Дата реєстрації в ядрі системи'
            }, {
                code: 'is_deleted',
                type: 'string',
                verbose: 'Статус'
            }, {
                code: 'last_central_request_status',
                type: 'string',
                verbose: 'Статус роботи'
            }, {
                code: 'last_central_request_error',
                type: 'string',
                verbose: 'Остання помилка'
            }, {
                code: 'last_central_request_at',
                type: 'date',
                verbose: 'Дата останнього запиту службами моніторингу порталу'
            }]
        }
    },
};

export default DISPLAY_SETTINGS;